import React from 'react';
import { object } from 'prop-types';

const propTypes = {
  glossary: object.isRequired,
};

const defaultProps = {
  glossary: {},
};

const FaqGlossaryDictionary = ({ glossary }) => (
  <div className="clearfix faq-glossary-row-lang">
    {Object.keys(glossary).map(key => (
      <div key={key}>
        {glossary[key].length > 0 ? (
          <a href={`#FaqGlossaryLine_${key}`}>
            <span className="has-items">{key}</span>
          </a>
        ) : (
          <span>{key}</span>
        )}
      </div>
    ))}
  </div>
);

FaqGlossaryDictionary.propTypes = propTypes;
FaqGlossaryDictionary.defaultProps = defaultProps;

export default FaqGlossaryDictionary;
